@if (!loaded) {
  <div class="chart-placeholder-container">
    <app-spinner [isLoading]="true"></app-spinner>
  </div>
}
